import { render, staticRenderFns } from "./CostBearersInfoCard.vue?vue&type=template&id=01ee417c"
import script from "./CostBearersInfoCard.vue?vue&type=script&lang=ts"
export * from "./CostBearersInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports